import { AverageBuyPriceQueryParams } from '@prediction-market/common';
import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../../../lib/fetcher';
import { buildSearchParams, ensureData } from '../utils';

import { useAuthenticatedWallet } from '@/hooks/ui/use-authenticated-wallet';
import { compareData } from '@/utils/fetch.utils';

export function useAvgBuyPrice(marketId: number, outcome: 'YES' | 'NO') {
  const { publicKey } = useAuthenticatedWallet();

  return useQuery({
    refetchInterval: 10 * 1000,
    queryKey: ['avg-buy-price', publicKey, marketId, outcome],
    structuralSharing: compareData,
    queryFn: async () => {
      const client = apiClient();

      if (!publicKey) return null;

      const params = buildSearchParams({
        marketId: marketId.toString(),
        outcome,
        userId: publicKey.toBase58(),
      } satisfies AverageBuyPriceQueryParams);

      const response = await client.get<{ averageBuyPrice: number }>(
        `/business-metrics/average-buy-price?${params}`,
      );

      return ensureData(response, 'admin-fees');
    },
  });
}
